module.exports = __webpack_public_path__ + "fonts/montserrat-latin-200italic.6e5b375.woff2";